'use client'

import Header from '@/components/header/Header'
// import logoMain from '@/assets/img/logo-main.svg'
import MainOrder from '@/components/main/MainOrder'
import materialsSettings from '@/assets/data/main-materials-slider.json'
import catalogSettings from '@/assets/data/main-catalog-slider.json'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useGetAllAnimalTypesQuery } from '@/redux/services/admin/animalTypesApi'
import { useGetMaterialsCategoriesQuery } from '@/redux/services/materialsApi'

import Calendar from '@/components/Calendar/Calendar'
import { useTranslation } from 'react-i18next'

import NewsBannerUisngNewestNews from '@/components/news/NewsBannerUisngNewestNews'
import Image from 'next/image'
import { useModal } from '@/components/Modal/Modal'
import { Intro } from './Intro'

import s from './MainModulev1.module.scss'
import { MainCards } from './MainCards'
import { MainSliderCatalog } from './MainSliderCatalog'
import { TestingSlider } from '@/shared/Slider/TestingSlider/TestingSlider1'
import classNames from 'classnames'
import SliderPageThreeTest from './SliderPageThreeTest/SliderPageThreeTest'
import { Footer } from './Footer'
import FooterContacts from '@/components/Footer/FooterContacts'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { toggleTheme as toggleThemeAction } from '@/shared/model/themeSlice'
import { useLocalStorage } from 'usehooks-ts'

export interface MainModuleProps {
    testing?: boolean
    isOtherIntro?: boolean
    isLightThemeServer?: boolean
    lightTheme?: boolean
}

const MainModulev1 = ({ isLightThemeServer, isOtherIntro }: MainModuleProps) => {
    const { t } = useTranslation()

    const isLightThemeClient = useAppSelector(state => {
        return state.themeSlice.isLightTheme
    })
    const [isLight, setIsLight] = useLocalStorage('isLightTheme', false)
    const isLightTheme = useMemo(
        () => (isLightThemeClient === null ? (isLight ? isLight : isLightThemeServer) : isLightThemeClient),
        [isLightThemeServer, isLightThemeClient]
    )

    const dispatch = useAppDispatch()

    const toggleTheme = useCallback(() => dispatch(toggleThemeAction()), [dispatch])

    const { data: animalTypes } = useGetAllAnimalTypesQuery()

    const { data: materialsCategoriesData } = useGetMaterialsCategoriesQuery()

    const catalogData = useMemo(() => {
        return {
            title: t('productsCatalog'),
            description: t('productsCatalog_'),
            buttonText: t('watchCatalog'),
            buttonLink: '/catalog'
        }
    }, [t])

    const usefulMaterialData = useMemo(() => {
        return {
            title: t('usefulMaterialsTitle'),
            description: t('usefulAboutDescription'),
            buttonText: t('learnMore'),
            buttonLink: '/useful-materials'
        }
    }, [t])

    return (
        <main className={classNames('main', isLightTheme ? s.lightTheme : '')}>
            {/* !!!!!!!! СДЕЛАТь  */}
            <div
                style={{
                    position: 'fixed',
                    zIndex: -2,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    background: 'linear-gradient(180deg, #3156A8 21%, #2D3079 108%)'
                }}
            >
                <Image
                    fill
                    src={'/assets/img/bckgr.png'}
                    alt=''
                />
            </div>
            <Header
                toggleTheme={toggleTheme}
                isLightTheme={isLightTheme}
                isWhiteLogo={isLightTheme}
                className={s.headerWhite}
            />
            <Image
                src={'/assets/img/mainModulev1.png'}
                alt=''
                style={{ mixBlendMode: 'overlay', opacity: 0.7 }}
                className={`video__welcome ${s.backgroundImage}`}
                fill
            ></Image>
            <div>
                <SliderPageThreeTest />
            </div>
            <div className={classNames('container', s.introContainer, s.introContainerPageThreeTest)}>
                <div className={classNames(s.top_container, s.top_containerPageThree)}></div>
            </div>
            <div className='container'>
                <MainCards lightTheme={isLightTheme} />
            </div>
            {animalTypes && (
                <MainSliderCatalog
                    list={animalTypes}
                    zIndex={6}
                    type='catalog'
                    settings={catalogSettings}
                    data={catalogData}
                    lightTheme={isLightTheme}
                />
            )}
            <div
                style={{ display: 'flex', flexDirection: 'column' }}
                className='container'
            >
                <MainOrder
                    mt={172}
                    item={{
                        tag: t('forCustomers'),
                        title: t('customOrder'),
                        text: [t('customOrderText'), t('customOrderText1')]
                    }}
                    link1='/'
                    btnContent={t('sendEnquiry')}
                    lightTheme={isLightTheme}
                />
            </div>
            <div
                style={{ display: 'flex', flexDirection: 'column' }}
                className='container'
            >
                <Calendar lightTheme={isLightTheme} />
                <h2 className={classNames('main__section-title', isLightTheme ? s.colorOrange : '')}>
                    {t('newsTitle')}
                </h2>
                <NewsBannerUisngNewestNews lightTheme={isLightTheme} />
            </div>
            {materialsCategoriesData && (
                <MainSliderCatalog
                    list={materialsCategoriesData}
                    type='useful-materials'
                    settings={materialsSettings}
                    data={usefulMaterialData}
                    lightTheme={isLightTheme}
                />
            )}
            <div
                className='container'
                style={{ marginTop: '132px', marginBottom: '132px' }}
            >
                <h3 className={s.section_header}>{t('contacts')}</h3>
                <FooterContacts />
            </div>
            <Footer mapTheme={isLightTheme ? 'light' : 'dark'} />
        </main>
    )
}

export default MainModulev1
